// Shared search-scope state (ZIP + radius) for the checkup steps whose search
// is geographic: pharmacy, doctors and hospitals. Renders through
// components/checkup/parts/SearchScopeRow.vue.
//
// Contract for the consuming step:
//   - declares a `target` prop carrying a `zip_code` snapshot (every checkup
//     page's formWithZip proxy provides one — see pages/checkup/*.vue)
//   - sets the custom `searchDistance` component option to the radius its
//     search used before this row existed (same pattern as `autosave` in
//     mixins/checkup-page.js, read via $options in mixins/survey-form.js)
//   - assigns `this.query = query` at the top of its own onSearch(), so the
//     Update button knows what to re-run
export default {
    data () {
        return {
            // Local, editable copy of the search ZIP. target.zip_code is a
            // read-only snapshot of the store's zipCode getter (see each
            // page's formWithZip proxy) — this row re-runs the search with the
            // local value rather than trying to write back through it.
            //
            // In production SPA mode (direct visit/refresh), the survey hasn't
            // loaded yet when data() runs, so target.zip_code is still
            // undefined at snapshot time — this would leave `zip` undefined
            // forever with nothing to ever populate it. zipTouched tracks
            // whether the client has since typed their own ZIP (in which case
            // a later store update to target.zip_code must NOT clobber what
            // they typed); the watcher below fills `zip` in once the real
            // value arrives, but only while the client hasn't touched it.
            zip: this.target.zip_code,
            zipTouched: false,
            // Search radius in miles. Defaults to whatever the step's search
            // hard-coded before the client could change it.
            distance: this.$options.searchDistance || 25,
            // Last query the step searched for, so the Update button can
            // re-run it against the new scope.
            query: '',
        }
    },
    computed: {
        // Mirrors the store's `distances` getter (store/index.js) so the
        // checkup radius choices stay identical to the agent-facing
        // form/Pharmacies.vue and form/Providers.vue pickers.
        distances () { return this.$store.getters.distances },
    },
    watch: {
        'target.zip_code' (v) {
            if (!this.zipTouched && v) {
                this.zip = v
            }
        },
    },
    methods: {
        // Only a client-typed ZIP sets zipTouched — assigning `this.zip` from
        // the watcher above must not, or the first store-driven fill would
        // permanently lock out every later one.
        onZipInput (v) {
            this.zip = v
            this.zipTouched = true
        },
        // Re-run the current search against the edited ZIP/radius. Nothing to
        // do until the client has actually searched for something — the scope
        // is still remembered and applied to their next search.
        onScopeUpdate () {
            if (!this.query) { return }
            this.onSearch(this.query)
        },
    },
}
